import { resolveMultiplier } from './zeroPriceWarnings';

/**
 * Amount billed for one quotation line.
 * Matches quotation Total(R): frozen unit price × multiplier.
 * Catalogue extras (catering/cleaning/laundry/other) are already inside unit_price.
 */
export function quoteLineBilledAmount(item) {
    if (!item) return 0;
    const parsed = parseFloat(item.unit_price ?? item.price);
    const unitPrice = Number.isFinite(parsed) ? parsed : 0;
    return unitPrice * resolveMultiplier(item.multiplier);
}
